
import { useEffect, useState } from 'react';
import { cn } from '@jk-core/utils';
import CloseIcon from '@/assets/close.svg';
import styles from './Calendar.module.scss';
import DateLabel from './components/DateLabel';
import DayTile from './components/DayTile';
import useCalendarNav from './hooks/useCalendarNav';
import { CalendarRange } from './type';
import getWeeksInMonth from './utils/getWeeksInMonth';

interface CalendarProps {
  className?: string;
  date: CalendarRange;
  onChange:(date:CalendarRange)=>void;
  min: Date;
  max: Date;
  onClose?: () => void;
}

export default function RangeCalendar({
  className = '', date: selectedDate = [null, null], onChange, onClose,
  min, max,
}: CalendarProps) {
  const method = 'day';
  const [viewDate, setViewDate] = useState<Date>(selectedDate?.[0] || new Date());
  const [hoverDate, setHoverDate] = useState<Date | null>(null);
  const weeksInMonth = getWeeksInMonth(viewDate);

  const onDayClick = (day: Date, maintenance = false) => {
    if (!maintenance) setViewDate(day);
    if (!selectedDate[0] || (!!selectedDate[0] && !!selectedDate[1])) {
      onChange([day, null]);
    }
    if (!!selectedDate[0] && !selectedDate[1]) {
      if (day < selectedDate[0]) {
        onChange([day, null]);
      } else {
        onChange([selectedDate[0], day]);
      }
    }
  };

  const { disabled, onArrowClick } = useCalendarNav({
    method, selectMode: 'day', viewDate, setDate: setViewDate, min, max,
  });

  useEffect(() => {
    if (viewDate > max) {
      setViewDate(max);
    }
    if (viewDate < min) {
      setViewDate(min);
    }
  }, [viewDate, max, min]);

  return (
    <div className={cn({
      [styles.calendar]: true,
      [styles['calendar--range']]: true,
      [className]: !!className,
    })}
    >
      <div className={styles.calendar__close}>
        {onClose && (
          <CloseIcon onClick={onClose} />
        )}
      </div>
      {/* 일/월/년 선택 버튼 */}
      <div className={styles['calendar__range-tile']}>
        <div className={styles.calendar__wrapper}>
          <DateLabel
            viewDate={viewDate}
            method="day"
            onArrowClick={onArrowClick}
            disabled={disabled}
            hideArrow="next"
            range
          />
          <DayTile
            hoverDate={hoverDate}
            setHoverDate={(day) => setHoverDate(day)}
            selectedDate={selectedDate}
            weeksInMonth={weeksInMonth}
            handleDayClick={onDayClick}
            hideAfter
            max={max}
            min={min}
            range
          />
        </div>
        <div className={styles.calendar__wrapper}>
          <DateLabel
            viewDate={new Date(
              viewDate.getFullYear(),
              viewDate.getMonth() + 1,
              1,
            )}
            method="day"
            onArrowClick={onArrowClick}
            disabled={disabled}
            hideArrow="prev"
            range
          />
          <DayTile
            hoverDate={hoverDate}
            setHoverDate={(day) => setHoverDate(day)}
            selectedDate={selectedDate}
            weeksInMonth={getWeeksInMonth(new Date(
              viewDate.getFullYear(),
              viewDate.getMonth() + 1,
              1,
            ))}
            handleDayClick={(day) => onDayClick(day, true)}
            hideBefore
            hideAfter
            max={max}
            min={min}
            range
          />
        </div>
      </div>
    </div>
  );
}
